<template>
  <div class="speedChange_wrapper common_radius">
    <div class="condition_wrapper">
      <div class="condition_group">
        <div class="condition_label">
          风速高度
        </div>
        <div class="condition_item-wrapper">
          <searchCondition
            :options="speedHeightArr"
            labelProps="heights"
            valueProps="channelId"
            v-model="checkSpeedHeight"
          ></searchCondition>
        </div>
      </div>
      <div class="condition_group">
        <div class="condition_label">
          查询项
        </div>
        <div class="condition_item-wrapper">
          <searchCondition
            :options="searchArr"
            labelProps="name"
            valueProps="channelId"
            v-model="checkSearchArr"
          ></searchCondition>
        </div>
      </div>
      <div class="search_btn">
        <ct-button type="primary" :btn-click="search">查询</ct-button>
      </div>
    </div>
    <div class="charts_tab">
      <span
        @click="changeCharts('month')"
        :class="{ active: chartIndexTab == 'month' }"
        >月变化</span
      >
      <span
        @click="changeCharts('day')"
        :class="{ active: chartIndexTab == 'day' }"
        >日变化</span
      >
    </div>
    <div class="charts_wrapper">
      <echart
        :option="echartsOptions"
        :notMerge="true"
        :divStyle="{ height: '400px', width: '99%' }"
      ></echart>
      <div style="padding: 0 10px">
        <el-table
          :data="echartTableData"
          style="width:100%"
          :header-cell-style="{
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#444455',
            backgroundColor: 'rgb(180, 211, 238)'
          }"
          :cell-style="{}"
          border
          :row-class-name="tableRowClassName"
          cell-class-name="speedCell"
          header-cell-class-name="speedCell"
        >
          <el-table-column
            v-for="item in tableHeaders"
            :prop="item"
            :label="item"
            :key="item"
            align="center"
            min-width="15%"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import isEqual from 'lodash/isEqual';
import searchCondition from '../components/searchContidions';
export default {
  data() {
    return {
      speedHeightArr: [],
      color: [
        '#F44336',
        '#9C27B0',
        '#3F51B5',
        '#00BCD4',
        '#009688',
        '#8BC34A',
        '#FF9800',
        '#607D8B',
        '#9E9E9E',
        '#795548',
        '#673AB7',
        '#03A9F4'
      ],
      activeIndex: 'month',
      searchArr: [
        {
          name: '风速',
          channelId: 1,
          checked: true
        },
        {
          name: '风功率',
          channelId: 2,
          checked: true
        }
      ],
      chartIndexTab: 'month',
      echartsOptions: null,
      echartTableData: [],
      tableHeaders: [],
      checkSpeedHeight: [],
      checkSearchArr: [1, 2]
    };
  },
  computed: {
    towerInfo: function() {
      return this.$store.state.WindData.towerObj;
    }
  },
  watch: {
    towerInfo: {
      handler(newVal, oldValue) {
        if (!isEqual(newVal, oldValue)) {
          this.getData(newVal);
        }
      },
      deep: true
    },
    checkSpeedHeight: {
      handler(newVal) {
        console.log(newVal);
      },
      deep: true
    }
  },
  methods: {
    search() {
      //console.log(this.checkSpeedHeight);
      if (!this.checkSpeedHeight.length) {
        return this.$message.warning('请选择通道！');
      }
      let channelIds = this.checkSpeedHeight;
      let speedState = this.checkSearchArr.includes(1);
      let powerState = this.checkSearchArr.includes(2);
      this.getData(
        this.towerInfo,
        {
          speedState: Number(speedState),
          powerState: Number(powerState),
          channelIds: channelIds.join(',')
        },
        true
      );
    },
    getSeriesAndLegenData(data) {
      const seriesData = [];
      let legenData = [];
      let channelIdList = this.checkSpeedHeight.sort((a, b) => a - b);
      let speedState = this.checkSearchArr.includes(1);
      let powerState = this.checkSearchArr.includes(2);
      for (let i = 0; i < channelIdList.length; i++) {
        let temp = this.speedHeightArr.find(
          v => v.channelId === channelIdList[i]
        );
        let { channelId, heights } = temp || {};
        if (speedState) {
          let dataName = 'speed_' + channelId;
          let name = heights + '风速';
          let speedLegend = {
            name: name,
            icon: 'line'
          };
          legenData.push(speedLegend);
          let objSpeed = {
            name: name,
            type: 'line',
            yAxisIndex: 0,
            symbol: 'circle',
            symbolSize: 2,
            itemStyle: {
              normal: {
                color: this.color[i],
                lineStyle: {
                  width: 2,
                  type: 'solid' //'dotted'虚线 'solid'实线
                }
              }
            },
            data: data[dataName]
          };
          seriesData.push(objSpeed);
        }
      }
      legenData.push('\n');
      for (let i = 0; i < channelIdList.length; i++) {
        let temp = this.speedHeightArr.find(
          v => v.channelId === channelIdList[i]
        );
        let { channelId, heights } = temp;
        if (powerState) {
          let dataName = 'power_' + channelId;

          let name = heights + '风功率';
          legenData.push(name);
          let objPower = {
            name: name,
            type: 'line',
            yAxisIndex: 1,
            symbol: 'circle',
            symbolSize: 2,
            itemStyle: {
              normal: {
                color: this.color[i],
                lineStyle: {
                  width: 2,
                  type: 'dotted' //'dotted'虚线 'solid'实线
                }
              }
            },
            data: data[dataName]
          };
          seriesData.push(objPower);
        }
      }
      return {
        legenData,
        seriesData
      };
    },
    setOption(data, type) {
      const titleMap = {
        day: '日变化',
        month: '月变化'
      };
      let { legenData = [], seriesData = [] } = this.getSeriesAndLegenData(
        data
      );
      //console.log({ legenData, seriesData });
      this.echartsOptions = {
        title: {
          show: true,
          text: titleMap[type],
          textStyle: {
            color: '#222233',
            fontFamily: 'FangSong'
          },
          top: '2',
          left: 'center'
        },
        legend: {
          textStyle: {
            color: '#222233'
          },
          // icon: 'line',
          itemWidth: 15,
          itemHeight: 5,
          top: '8%',
          orient: 'vertical',
          y: 'center',
          x: 'right',
          align: 'left',
          data: legenData
        },
        grid: {
          x: '40',
          left: '50',
          right: '250'
        },
        xAxis: {
          name: type === 'month' ? '月份' : '小时',
          nameLocation: 'end',
          boundaryGap: false,
          type: 'category',
          data:
            type === 'month'
              ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
              : [
                  0,
                  1,
                  2,
                  3,
                  4,
                  5,
                  6,
                  7,
                  8,
                  9,
                  10,
                  11,
                  12,
                  13,
                  14,
                  15,
                  16,
                  17,
                  18,
                  19,
                  20,
                  21,
                  22,
                  23
                ],
          axisLine: {
            lineStyle: {
              color: '#222233'
            }
          },
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#222233' //这里用参数代替了
            }
          }
        },
        yAxis: [
          {
            name: '平均风速(m/s)',
            nameLocation: 'end',
            type: 'value',
            min: 0,
            max: value => {
              // if (value.max <= 10) {
              //   return 10;
              // }

              let max = value.max * 1.2;
              let val = max / 5;
              const round = true;
              const exponent = Math.floor(Math.log(val) / Math.LN10);
              const exp10 = Math.pow(10, exponent);
              const f = val / exp10; // 1 <= f < 10
              let nf;
              if (round) {
                if (f < 1.5) {
                  nf = 1;
                } else if (f < 2.5) {
                  nf = 2;
                } else if (f < 4) {
                  nf = 3;
                } else if (f < 7) {
                  nf = 5;
                } else {
                  nf = 10;
                }
              } else {
                if (f < 1) {
                  nf = 1;
                } else if (f < 2) {
                  nf = 2;
                } else if (f < 3) {
                  nf = 3;
                } else if (f < 5) {
                  nf = 5;
                } else {
                  nf = 10;
                }
              }
              val = nf * exp10;
              return val * 5 <= value.max ? val * 6 : val * 5;
            },
            axisLine: {
              lineStyle: {
                color: '#222233'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#222233' //这里用参数代替了
              }
            }
          },
          {
            name: '风功率密度(W/㎡)',
            nameLocation: 'end',
            type: 'value',
            axisLabel: {
              showMinLabel: false,
              show: true,
              textStyle: {
                color: '#222233' //这里用参数代替了
              }
            },
            axisLine: {
              lineStyle: {
                color: '#222233'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            },
            min: 0,
            max: value => {
              let max = value.max * 1.2;
              let val = max / 5;
              const round = true;
              const exponent = Math.floor(Math.log(val) / Math.LN10);
              const exp10 = Math.pow(10, exponent);
              const f = val / exp10; // 1 <= f < 10
              let nf;
              if (round) {
                if (f < 1.5) {
                  nf = 1;
                } else if (f < 2.5) {
                  nf = 2;
                } else if (f < 4) {
                  nf = 3;
                } else if (f < 7) {
                  nf = 5;
                } else {
                  nf = 10;
                }
              } else {
                if (f < 1) {
                  nf = 1;
                } else if (f < 2) {
                  nf = 2;
                } else if (f < 3) {
                  nf = 3;
                } else if (f < 5) {
                  nf = 5;
                } else {
                  nf = 10;
                }
              }
              val = nf * exp10;
              return val * 5 <= value.max ? val * 6 : val * 5;
            }
          }
        ],
        tooltip: {
          trigger: 'axis'
        },
        color: this.color,
        backgroundColor: '#fff',
        series: seriesData
      };
    },
    getTableData(data, type) {
      //时间为第一行
      let timeCategory = type === 'day' ? 'hourList' : 'monthList';
      let tableData = []; //表格内容
      let tableHeaders = []; //表头数据
      tableHeaders.unshift('时间');
      tableHeaders.push(...data[timeCategory]);
      let channelIdList = this.checkSpeedHeight;

      let rowDataArray = [];
      let speedState = this.checkSearchArr.includes(1);
      let powerState = this.checkSearchArr.includes(2);
      for (let m = 0; m < channelIdList.length; m++) {
        let channelItem = this.speedHeightArr.find(
          v => v.channelId === channelIdList[m]
        );
        let { channelId, heights } = channelItem || {};

        let speedRowName = heights + '风速';
        let powerRowName = heights + '风功率';
        let speedDataName = 'speed_' + channelId;
        let powerDataName = 'power_' + channelId;
        if (speedState) {
          rowDataArray.push([speedRowName, ...data[speedDataName]]);
        }
        if (powerState) {
          rowDataArray.push([powerRowName, ...data[powerDataName]]);
        }
      }
      for (let m = 0; m < rowDataArray.length; m++) {
        let rowData = {};
        for (let n = 0; n < tableHeaders.length; n++) {
          let headerName = tableHeaders[n];
          let colContent = rowDataArray[m][n];
          let item = {};
          item[headerName] = colContent;
          rowData = Object.assign(rowData, item);
        }
        tableData.push(rowData);
      }

      this.echartTableData = tableData;
      this.tableHeaders = tableHeaders;
      // if (type == 'day') {
      //   this.dayTableHeaders = tableHeaders;
      //   this.firstDayTableHeader = this.dayTableHeaders.shift();
      //   this.dayTableData = tableData;
      // } else if (type == 'month') {
      //   this.monthTableData = tableData;
      //   this.monthTableHeaders = tableHeaders;
      //   // this.firstMonthTableHeader = this.monthTableHeaders.shift();
      //   // this.showMonthTable = true; //显示日变化表格
      // }
    },

    async getData(towerInfo, params = {}, isSearch) {
      this.showMonthTable = false; //显示日变化表格
      let { towerId, versionId } = towerInfo || {};
      if (!towerId && !versionId) return;
      let isMonth = this.chartIndexTab === 'month';
      let url = isMonth
        ? '/winddata/WindAnalyze/getSpeedMonthData'
        : '/winddata/WindAnalyze/getSpeedDayData';
      const res = await this.$fetch(url, {
        module: 'windData',
        // showLoading: true,
        showError: true,
        params: {
          channelIds: 0, //
          powerState: 1, //
          speedState: 1, //
          towerId,
          versionId,
          ...params
        }
      });
      let data = res.data || {};
      let { channelList = [] } = data;
      if (!isSearch) {
        this.checkSpeedHeight = [];
        this.checkSearchArr = [1, 2];
        this.speedHeightArr = channelList.map(item => {
          item.checked = true;
          this.checkSpeedHeight.push(item.channelId);
          return item;
        });
      }
      //console.log(this.speedHeightArr, 'this.speedHeightArr');
      //console.log(this.checkSpeedHeight, 'this.checkSpeedHeight');
      this.setOption(res.data, this.chartIndexTab);
      this.getTableData(res.data, this.chartIndexTab);
    },
    changeCharts(tab) {
      if (this.chartIndexTab === tab) return;
      this.chartIndexTab = tab;
      this.getData(this.towerInfo, tab);
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 !== 0) {
        return 'custom-table-row-odd';
      } else {
        return 'custom-table-row-even';
      }
    }
  },
  mounted() {
    // this.initDay();
    this.getData(this.towerInfo);
  },
  components: {
    searchCondition
  }
};
</script>
<style lang="less" scoped>
.speedChange {
  &_wrapper {
    background-color: rgb(240, 245, 250);
    padding: 10px;
    .condition {
      &_wrapper {
        background: #2f6ba44d;
        padding: 13px 20px 13px 10px;
        border-radius: 8px;
        position: relative;
      }
      &_group {
        display: flex;
        &:first-child {
          margin-bottom: 20px;
        }
      }
      &_label {
        font-size: 16px;
        font-weight: bold;
        color: #222233;
        margin-right: 10px;
        display: inline-block;
        height: 32px;
        line-height: 32px;
        width: 70px;
        text-align: right;
      }
      &_item {
        width: 110px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: #fff;
        border: 1px solid
          linear-gradient(
            90deg,
            rgba(8, 120, 191, 0.11),
            rgba(0, 86, 170, 0.11)
          )
          1 1;
        border-radius: 6px;
        display: inline-block;
        cursor: pointer;
        margin: 0 12px 8px 0;
        &.active {
          background: linear-gradient(to right, #0878bfff 0%, #0056aaff 100%);
          .text {
            color: #fff;
          }
          .checked {
            display: inline-block;
          }
        }
        .text {
          color: #888899ff;
          font-size: 14px;
          font-weight: bold;
        }
        .checked {
          display: inline-block;
          width: 20px;
          height: 20px;
          border-radius: 50px;
          background: rgb(240, 245, 250);
          text-align: center;
          line-height: 20px;
          margin-right: 12px;
          display: none;
          i {
            font-size: 14px;
            color: #0057aaff;
          }
        }
        &-wrapper {
          flex: 1;
        }
      }
    }
    .search_btn {
      position: absolute;
      bottom: 20px;
      right: 20px;
    }

    .charts_tab {
      height: 28px;
      font-size: 0;
      border: 1px solid #0057aaff;
      width: 170px;
      display: flex;
      border-radius: 8px;
      align-items: center;
      overflow: hidden;
      line-height: 26px;
      box-sizing: border-box;
      margin: 20px 0;
      span {
        display: inline-block;
        font-size: 14px;
        color: #0057aaff;
        text-align: center;
        flex: 1;
        height: 100%;
        cursor: pointer;
        &.active {
          color: #fff;
          background: #0057aaff;
          background: linear-gradient(to right, #0878bfff 0%, #0056aaff 100%);
        }
      }
    }
    .charts_wrapper {
      background: #fff;
    }
  }
}
</style>
<style lang="less">
#hot-display-license-info {
  display: none !important;
}
.data-analysis-pad {
  .el-date-editor {
    &.el-input {
      width: 180px;
    }
    .el-icon-time {
      display: none;
    }
  }
}
.my-hot-table-class {
  &.intergity {
    thead {
      th {
        background-color: #0076a2;
        color: #fff;
      }
    }
    tbody {
      text-align: center;
      color: #fff;
    }
  }
}
.speedCell {
  .cell {
    padding: 0 5px !important;
  }
}
</style>
